import * as React from 'react';
import { connect, Provider } from 'react-redux';
import { withRouter } from 'react-router';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

import { withDefaultStyles } from '../../utils/material-ui/hoc';
import Main from './main';
import { store } from './store';

const s = store();
const p = persistStore(s);
class Datafiniti extends React.Component<any, any> {
  public render() {
    const { authentication, tenant } = this.props
    return (
      <div style={this.props.style}>
        <Provider store={s}>
          <PersistGate loading={null} persistor={p}>
            <Main authentication={authentication} tenant={tenant} />
          </PersistGate>
        </Provider>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  console.log('sf index', state)
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(Datafiniti)));



// WEBPACK FOOTER //
// ./src/sub-projects/datafiniti/index.tsx